<template>
  <div class="step-wrapper" id="step1">
    <Menu current="1" :finish="finish"></Menu>
    <div class="step-inner" :class="'part' + curPart">
      <div class="cp_list1">
        <div class="field">
          <img src="~@static/funding_cpunk/project_item_1a.png" class="cover1" alt="" />
          <img :src="coverImgUrl" alt="" v-if="cover" class="img" />
          <div class="cover-img cover-bg" v-else></div>
          <img src="~@static/funding_cpunk/project_item_1b.png" class="cover2" alt="" />
          <div class="theme">精选派对</div>
          <div class="t">
            <p class="t1">{{ title == '' ? '活动名称' : title }}</p>
            <p class="t2">{{ summary == '' ? '活动简介' : summary }}</p>
            <div class="t3">
              <div class="t3_1">
                <img class="icon" src="~@static/fundingnew/profile/icon-location.png" />
                <div class="text">{{ city == '' ? '在哪造' : city }}</div>
              </div>
              <div class="t3_2">
                <img class="icon" src="~@static/fundingnew/profile/icon-like.png" />
                <div class="text">150</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tags-list2 clearfix">
          <template v-if="tagsName.length">
            <div class="new-tag-item new-tag-item--normal" v-for="(item, index) in tagsName" :key="index">#{{ item }}</div>
          </template>
          <template v-else>
            <div class="new-tag-item new-tag-item--normal">#活动标签</div>
            <div class="new-tag-item new-tag-item--normal">#活动标签</div>
            <div class="new-tag-item new-tag-item--normal">#活动标签</div>
          </template>
        </div>
      </div>

      <div class="mask" @click.stop="hideTags"></div>

      <div class="step1-1-tip" v-if="curPart == 1">
        <img class="step1-1" src="~@static/funding_cpunk/creation/step1_1.png" style="max-width: 100%" alt="" />
        <div class="form-input project-cover-upload" v-if="curPart == 1">
          <div class="cover-img" v-if="cover" :style="{ 'background-image': 'url(' + coverImgUrl + ')' }"></div>
          <div class="cover-img cover-bg" v-else></div>
          <img src="~@static/funding_cpunk/project_item_1b.png" class="cover2" alt="" />
          <vue-core-image-upload
            style="width: 100%; height: 100%; opacity: 0"
            :class="['button', 'file-btn', 'btn-lg', 'btn-block']"
            :crop="false"
            @imageuploaded="imageuploaded"
            @imageuploading="imageuploading"
            inputOfFile="file"
            :max-file-size="5242880"
            :compress="30"
            :max-width="200"
            input-accept="image/*"
            :url="uploadUrl"
          >
          </vue-core-image-upload>
        </div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part1.active ? 'active' : ''">下一步</div>
      </div>

      <div class="step1-2-tip" v-if="curPart == 2">
        <img class="step1-2" src="~@static/funding_cpunk/creation/step1_2.png" />
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part1.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part2.active ? 'active' : ''">下一步</div>
        <div class="form-input">
          <input class="form-control placeholder-style" placeholder="活动名称" v-model="title" @input="bindTitleChange" />
        </div>
      </div>

      <div class="step1-3-tip" v-if="curPart == 3">
        <img class="step1-3" src="~@static/funding_cpunk/creation/step1_3.png" />
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part2.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part3.active ? 'active' : ''">下一步</div>
        <div class="form-input">
          <input class="form-control placeholder-style" placeholder="活动简介" v-model="summary" @input="bindSubTitleChange" />
        </div>
      </div>

      <div class="step1-4-tip" v-if="curPart == 4">
        <img class="step1-4" src="~@static/funding_cpunk/creation/step1_4.png" />
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part3.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part4.active ? 'active' : ''">下一步</div>
        <div class="form-input">
          <div class="form-control" @click="handleSelectLocation">
            <img class="icon" src="~@static/fundingnew/profile/icon-location.png" />{{ city == '' ? '在哪造' : city }}
          </div>
        </div>
      </div>

      <div class="step1-5-tip" v-if="curPart == 5">
        <img class="step1-5" src="~@static/funding_cpunk/creation/step1_5.png" />
        <div class="btn_step btn_prev" @click="bindToPrevPart" :data-part="curPart" :class="part4.active ? 'active' : ''">上一步</div>
        <div class="btn_step btn_reset" @click="bindResetTags" :data-part="curPart" :class="part5.active ? 'active' : ''">重选</div>
        <div class="btn_step btn_next" @click="bindToNextPart" :data-part="curPart" :class="part5.active ? 'active' : ''">下一步</div>
        <div class="tags-list1 clearfix">
          <div class="new-tag-item new-tag-item--normal" v-if="tagsName.length == 3" @click="showTags">#{{ tagsName[2] }}</div>
          <div class="new-tag-item new-tag-item--normal" v-else @click="showTags">#活动标签</div>
        </div>
      </div>
    </div>

    <loading v-if="loading" tips="上传中..."></loading>

    <fill-modal
      :isShow.sync="isShow"
      :isNewBtn="curPart == 4"
      :hasBtn="curPart == 4"
      :maskClick="curPart == 5"
      @cancel="fillModalCancel"
      @confirm="fillModalConfirm"
    >
      <div class="modal-title" v-if="curPart == 4">请选择你所在的城市</div>
      <div class="datepicker-wrap datepicker-wrap-funding" v-if="curPart == 4">
        <van-picker ref="cityPicker" item-height="7.46666vw" :columns="columns" columns-num="2" visible-item-count="3" @change="handleCityChange" />
      </div>
      <div class="tags-wrap" v-if="curPart == 5">
        <div class="pop-tags-list" v-if="tagsData.length">
          <div class="form-input">
            <input
              type="search"
              class="form-control custom-tag text-center placeholder-style"
              placeholder="自定义我的标签"
              v-model="cusTagName"
              @blur="bindCustomTagConfirm"
            />
          </div>
          <div class="tags-list-wrapper">
            <div
              v-for="(item, index) in tagsData"
              :key="index"
              :data-id="item.id"
              :data-index="index"
              class="new-tag-item"
              :class="{ 'new-tag-item--normal': !item.checked }"
              @click="bindTagsChange"
            >
              #{{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </fill-modal>
  </div>
</template>

<script>
import Menu from '../components/Menu'
import FillModal from '../components/FillModal'
import Loading from '@components/Loading'
import VueCoreImageUpload from 'vue-core-image-upload'
import { mapState, mapMutations } from 'vuex'
import cityJs from '@javascripts/cities.js'
const geolocation = new qq.maps.Geolocation()
import { behavior } from '@/utils/behavior'

export default {
  name: '',
  components: {
    Menu,
    FillModal,
    Loading,
    VueCoreImageUpload,
  },
  data() {
    return {
      cusTagName: '',
      isShow: false,
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      curPart: 1,
      part1: {
        active: false,
      },
      part2: {
        active: false,
      },
      part3: {
        active: false,
      },
      part4: {
        active: false,
      },
      part5: {
        active: false,
      },
      cover: '', ///upload/image/20201031/202010312142302744.png
      title: '',
      summary: '',
      location: [],
      province: '',
      city: '',
      tags: [],
      tagsName: [],
      tagsData: [],
      customtagsData: [],
      tags_checked: [],
      finish: 0,
      loading: false,
      from: '',
      columns: [],
      selectCity: [],
    }
  },
  computed: {
    coverImgUrl() {
      return this.hostUrl + this.cover
    },
    ...mapState(['fundingNewProjectCreate', 'authorization']),
  },
  created() {
    let { from } = this.$route.query
    if (from == 'preview') {
      this.from = 'preview'
    }
  },
  mounted() {
    let { cover, title, summary, province, city, tags, tagsName, customtagsData, step1Finish } = this.fundingNewProjectCreate

    if (typeof step1Finish != 'undefined') {
      this.cover = cover
      this.title = title
      this.summary = summary
      this.province = province
      this.city = city
      this.tags = tags
      this.tags_checked = tags
      this.tagsName = tagsName
      this.customtagsData = customtagsData
      this.part1.active = true
      this.part2.active = true
      this.part3.active = true
      this.part4.active = true
      this.part5.active = true
    }

    geolocation.getLocation(
      pos => {
        this.province = pos.province
        this.city = pos.city
        this.selectCity = [pos.province, pos.city]
      },
      fail => {
        if (fail.code === 1) {
          console.log('拒绝定位权限')
        }
      },
    )

    this.requestTags()
    this.finishedStep()
    this.getAreaData()
  },
  methods: {
    ...mapMutations(['setFundingNewProjectCreate']),
    getAreaData() {
      let mapData = []
      cityJs.citiesData.provinces.forEach(item => {
        let obj = {
          text: item.provinceName,
          children: item.citys.map(item2 => {
            return {
              text: item2.citysName,
            }
          }),
        }
        mapData.push(obj)
      })
      this.columns = mapData
    },
    requestTags() {
      this.$request
        .get(this.$apiConfig.tagsUrl, {
          params: {
            'per-page': 12,
          },
        })
        .then(res => {
          let resData = res.data
          let result = resData.data
          if (resData.code == 0 && result) {
            result.items.forEach(item => {
              if (this.tags.includes(item.id)) {
                item.checked = true
              } else {
                item.checked = false
              }
            })
            this.tagsData = result.items
          }
        })
    },
    fillModalCancel() {
      if (this.curPart == 4) {
        this.selectCity = []
      } else if (this.curPart == 5) {
        this.cusTagName = ''
      }
    },
    fillModalConfirm() {
      if (this.curPart == 4) {
        if (!this.selectCity.length) {
          this.selectCity = [this.columns[0].text, this.columns[0].children[0].text]
        }
        this.province = this.selectCity[0]
        this.city = this.selectCity[1]
        this.part4.active = true
      } else if (this.curPart == 5) {
        this.cusTagName = ''
      }
    },
    imageuploaded(res) {
      if (res.code == 0) {
        this.cover = res.data.base
        this.part1.active = true
      } else {
        alert('上传失败')
      }
      this.loading = false
    },
    imageuploading() {
      this.loading = true
    },
    handleSelectLocation() {
      this.isShow = true
      this.getCityIndex()
    },
    bindTitleChange() {
      if (this.title != '') {
        this.part2.active = this.title.length <= 8
      } else {
        this.part2.active = false
      }
    },
    bindSubTitleChange() {
      if (this.summary != '') {
        this.part3.active = this.summary.length <= 10
      } else {
        this.part3.active = false
      }
    },
    bindToNextPart(e) {
      let partId = e.currentTarget.dataset.part
      if (partId == 1) {
        if (this.cover == '') {
          alert('请上传封面')
          return
        }
        this.curPart = 2
        _jcq.push(['_track', 'yjhbccover_next'])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc19' })
      }
      if (partId == 2) {
        if (this.title == '') {
          alert('请输入夜计划标题')
          return
        }
        if (this.title.length > 8) {
          alert('最多可输入8个字符')
          return
        }
        this.curPart = 3
      }
      if (partId == 3) {
        if (this.summary == '') {
          alert('请输入夜计划简介')
          return
        }
        if (this.summary.length > 10) {
          alert('最多可输入10个字符')
          return
        }
        // this.getLocation();
        this.curPart = 4
      }
      if (partId == 4) {
        if (this.city.length == 0) {
          alert('夜计划在哪造？')
          return
        }
        this.curPart = 5
      }
      if (partId == 5) {
        if (this.tags.length == 0) {
          alert('选几个标签，让别人更容易找到你')
          return
        }

        _jcq.push([
          '_track',
          'yjhbccampaignlab_click',
          {
            label: this.tagsName.join(' '),
          },
        ])
        behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc20', name: this.tagsName.join(' ') })

        //保存Step1数据
        let step1Data = {
          cover: this.cover,
          title: this.title,
          summary: this.summary,
          province: this.province,
          city: this.city,
          tags: this.tags,
          tagsName: this.tagsName,
          customtagsData: this.customtagsData,
          tagsData: this.tagsData,
          step1Finish: true,
        }

        //存入storage
        this.setFundingNewProjectCreate({
          ...this.fundingNewProjectCreate,
          ...step1Data,
        })

        if (this.path_from == 'preview') {
          this.$router.replace({ path: '/fundingnew/creation/preview', query: this.$route.query })
        } else {
          this.$router.replace({ path: '/fundingnew/creation/step2', query: this.$route.query })
        }
      }
    },
    bindToPrevPart(e) {
      let partId = e.currentTarget.dataset.part
      if (partId == 2) {
        this.curPart = 1
      }
      if (partId == 3) {
        this.curPart = 2
      }
      if (partId == 4) {
        this.curPart = 3
      }
      if (partId == 5) {
        this.curPart = 4
        this.isShow = true
        this.getCityIndex()
      }
    },
    getCityIndex() {
      let i = this.columns.findIndex(item => item.text == this.province)
      let j = 0
      if (i == -1) {
        i = 0
      } else {
        j = this.columns[i].children.findIndex(item => item.text == this.city)
        if (j == -1) {
          j = 0
        }
      }
      this.$nextTick(() => {
        this.$refs.cityPicker.setIndexes([i, j])
      })
    },
    bindResetTags() {
      this.tagsData.forEach(item => {
        item.checked = false
      })
      this.tags = []
      this.tags_checked = []
      this.tagsName = [] //清除
      this.part5.active = false
    },
    hideTags() {
      this.isShow = false
    },
    showTags() {
      document.querySelector('#step1').scrollTop = 1000
      this.isShow = true
    },
    bindTagsChange(e) {
      let { id, index } = e.currentTarget.dataset
      let { tagsData, tags_checked } = this
      let checked = tagsData[index].checked

      if (!checked && tags_checked.length >= 3) {
        alert('最多可选3个标签')
        return
      }

      if (tags_checked.includes(+id)) {
        let i = tags_checked.indexOf(+id)
        tags_checked.splice(i, 1)
        tagsData[index].checked = false
      } else {
        tags_checked.push(+id)
        tagsData[index].checked = true
      }

      this.tags_checked = tags_checked
      this.tags = tags_checked
      this.tagsData = tagsData

      if (tags_checked.length) {
        this.part5.active = true
      } else {
        this.part5.active = false
      }
      this.$nextTick(() => {
        this.getTagNameList()
      })
    },
    getTagNameList() {
      let { tags, tagsData, customtagsData } = this
      let tagsName = []
      tags.forEach(item => {
        let filterTags1 = tagsData.find(item2 => item2.id == item)
        let filterTags2 = customtagsData.find(item2 => item2.id == item)
        if (filterTags1) {
          tagsName.push(filterTags1.name)
        }
        if (filterTags2) {
          tagsName.push(filterTags2.name)
        }
      })
      this.tagsName = tagsName.reverse()
    },
    handleCityChange(picker, value, index) {
      this.selectCity = value
    },
    finishedStep() {
      let { step1Finish, step2Finish, step3Finish } = this.fundingNewProjectCreate

      if (typeof step3Finish != 'undefined') {
        this.finish = 3
        return
      }
      if (typeof step2Finish != 'undefined') {
        this.finish = 2
        return
      }
      if (typeof step1Finish != 'undefined') {
        this.finish = 1
        return
      }
    },
    bindCustomTagConfirm() {
      if (this.cusTagName === '') {
        return
      }
      if (this.cusTagName.length > 4) {
        alert('自定义标签最多4个字符')
        return
      } else if (this.tags_checked.length >= 3) {
        alert('最多可选3个标签')
        return
      }

      this.$request
        .post(this.$apiConfig.tagsUrl, {
          name: this.cusTagName,
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0) {
            let result = resData.data
            this.tags_checked.push(result.id)
            this.customtagsData.push({
              id: result.id,
              name: this.cusTagName,
              checked: true,
            })
            this.tags = this.tags_checked
            this.part5.active = this.tags_checked.length > 0
            this.$nextTick(() => {
              this.getTagNameList()
            })
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.tags-list2 {
  margin-top: pxtow(20);
  .item-box {
    float: left;
    display: flex;
    align-items: center;
    height: pxtow(54);
    border: 2px solid #fff;
    border-radius: pxtow(54);
    background-color: #fd0fff;
    font-size: pxtow(24);
    padding: 0 pxtow(16);
    margin: 0 pxtow(10);
    white-space: nowrap;
    @include respond-to(desktop) {
      margin-bottom: 10px;
    }
  }
}

.form-input {
  input {
    background: transparent;
    outline: none;
    border: none;
  }
}

.placeholder-style {
  &::placeholder {
    color: #fff;
  }
  &.text-center {
    &::placeholder {
      text-align: center;
    }
  }
}
.text-center {
  text-align: center;
}

.step1-1-tip {
  position: absolute;
  left: 0;
  top: pxtow(150);
  width: 100%;
  z-index: 2;
  .btn_next {
    top: pxtow(360);
    left: pxtow(440);
  }
  .step1-1 {
    position: absolute;
    width: pxtow(300);
    height: pxtow(221);
    z-index: 2;
    top: pxtow(100);
    left: pxtow(393);
  }
  .cover-img {
    position: absolute;
    left: 0;
    @include center(y);
    width: 100%;
    height: 100%;
    border-radius: pxtow(10);
    object-fit: cover;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .project-cover-upload {
    position: absolute;
    left: pxtow(48);
    top: pxtow(12);
    width: pxtow(296);
    height: pxtow(334);
    .cover-bg {
      background-color: #000;
      background-repeat: no-repeat;
      background-size: pxtow(70) pxtow(70);
      background-image: url('~@static/funding_cpunk/creation/upload_img.png');
    }
    .cover2 {
      position: absolute;
      left: -0.8vw;
      top: -0.8vw;
      width: pxtow(310);
      height: pxtow(348);
      pointer-events: none;
    }
    z-index: 2;
  }
}

.step1-2-tip {
  position: absolute;
  left: 0;
  top: pxtow(150);
  width: 100%;
  z-index: 2;
  .form-input {
    position: absolute;
    left: pxtow(366);
    top: pxtow(84);
    z-index: 2;
    padding: 0 pxtow(10);
    background-color: #0d54f2;
    .form-control {
      width: pxtow(320);
      color: #fdff2b;
      font-size: pxtow(36);
      line-height: 1;
    }
  }
  .btn_prev {
    top: pxtow(360);
    left: pxtow(270);
  }
  .btn_next {
    top: pxtow(360);
    left: pxtow(510);
  }
  .step1-2 {
    position: absolute;
    width: pxtow(255);
    height: pxtow(120);
    top: pxtow(190);
    left: pxtow(360);
  }
}

.step1-3-tip {
  position: absolute;
  left: 0;
  top: pxtow(150);
  width: 100%;
  z-index: 2;
  .form-input {
    position: absolute;
    left: pxtow(366);
    top: pxtow(140);
    z-index: 2;
    padding: 0 pxtow(10);
    background-color: #0d54f2;
    .form-control {
      width: pxtow(320);
      color: #fff;
      font-size: pxtow(28);
      line-height: 1;
    }
  }
  .btn_prev {
    top: pxtow(360);
    left: pxtow(270);
  }
  .btn_next {
    top: pxtow(360);
    left: pxtow(510);
  }
  .step1-3 {
    position: absolute;
    width: pxtow(278);
    height: pxtow(120);
    top: pxtow(200);
    left: 52vw;
  }
}

.step1-4-tip {
  position: absolute;
  left: 0;
  top: pxtow(150);
  width: 100%;
  z-index: 2;
  .form-input {
    position: absolute;
    width: pxtow(160);
    height: pxtow(45);
    left: pxtow(366);
    top: pxtow(200);
    z-index: 2;
    background-color: #0d54f2;
    .form-control {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      color: #fff;
      font-size: 11px;
      white-space: nowrap;
      .icon {
        width: 2.66667vw;
        margin: 0.53333vw 1.6vw 0 pxtow(10);
      }
    }
  }
  .btn_prev {
    top: pxtow(430);
    left: pxtow(220);
  }
  .btn_next {
    top: pxtow(430);
    left: pxtow(460);
  }
  .step1-4 {
    position: absolute;
    width: pxtow(267);
    height: pxtow(120);
    top: pxtow(290);
    left: pxtow(300);
  }
}

.step1-5-tip {
  position: absolute;
  left: 0;
  top: pxtow(150);
  width: 100%;
  z-index: 2;
  .btn_step {
    width: pxtow(150);
  }
  .btn_prev {
    top: pxtow(635);
    left: pxtow(100);
  }
  .btn_reset {
    top: pxtow(635);
    left: pxtow(270);
  }
  .btn_next {
    top: pxtow(635);
    left: pxtow(435);
  }
  .step1-5 {
    position: absolute;
    width: pxtow(277);
    height: pxtow(108);
    top: pxtow(495);
    left: pxtow(205);
  }
  .tags-list1 {
    position: absolute;
    top: pxtow(380);
    left: 61vw;
    z-index: 2;
  }
}

// tag
// 预览
.tags-list2 {
  padding-left: pxtow(80);
}
.new-tag-item {
  width: pxtow(170);
  height: pxtow(54);
  line-height: pxtow(48);
  margin: 0 pxtow(10);
  text-align: center;
  white-space: nowrap;
  font-size: pxtow(22);
  font-weight: bold;
  font-family: 'SourceHanSansCN-Heavy';
  border-radius: 15px;
  float: left;
  border: 1px solid #fd0fff;
  background: #fff;
  color: #fd0fff;
  &--normal {
    background: #fd0fff;
    border: 2px solid #fff;
    color: #fff;
  }
}
.pop-tags-list {
  width: 100%;
  height: pxtow(430);
  position: absolute;
  bottom: 0;
  left: 0;
  background: #10104e;
  z-index: 5;
}

.pop-tags-list .custom-tag {
  display: block;
  width: pxtow(551);
  height: pxtow(55);
  margin: pxtow(40) auto pxtow(10);
  font-size: pxtow(22);
  padding: 0 pxtow(20);
  box-sizing: border-box;
  outline: none;
  border: 2px solid #fff;
  font-weight: bold;
  background-color: #fd0fff;
  border-radius: 15px;
  font-family: 'SourceHanSansCN-Heavy';
}
.tags-list-wrapper {
  width: pxtow(72.8 * 7.5);
  margin: pxtow(20) auto 0;
}
.tags-list-wrapper .new-tag-item {
  float: left;
  margin: pxtow(9) pxtow(5);
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/creation/Step1.vue